const orders = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.946%202l.994%2017.89a2%202%200%200%201-1.886%202.107l-.111.003H4.057a2%202%200%200%201-2-2c0-.055%200-.055.003-.11L3.054%202h17.892zm-1.892%202H4.946l-.889%2016h15.886l-.889-16zM9%206v2.5c0%201.248%201.385%202.5%203%202.5s3-1.252%203-2.5V6h2v2.5c0%202.4-2.323%204.5-5%204.5s-5-2.1-5-4.5V6h2z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  orders as default
};
//# sourceMappingURL=orders.svg.es.js.map
